import React from 'react';
import DiscoverMore from './DiscoverMore/DiscoverMore';
import CategoryBlock from './CategoryBlock/CategoryBlock';
import BlogBlock2 from './BlogBlock/BlogBlock2';
// import MiddlePageBanner from './Banners/MiddlePageBanner';
import SingleBanner2 from './Banners/SingleBanner2';
import Brands from './Brands/Brands';

export default class Home extends React.Component {
  public render() {
    return (
      <section className="home">
        <>
          <div className="h-full -ml-3.75 -mr-3.75 lg:-ml-7.5 lg:-mr-7.5">
            <SingleBanner2 slot="home-main" />
          </div>
          <DiscoverMore slot="home-discover-more" />
          <CategoryBlock />
          <Brands />
          {/* TELLI JA PROOVI: Hide this banner temporarily */}
          {/* <div className="h-full -ml-3.75 -mr-3.75 lg:-ml-7.5 lg:-mr-7.5">
            <MiddlePageBanner slot="home-single" />
          </div> */}
          <BlogBlock2 limit={6} />
          {/* <div className="h-full -ml-3.75 -mr-3.75 lg:-ml-7.5 lg:-mr-7.5">
            <FooterBanner slot="home-footer" />
          </div> */}
        </>
      </section>
    );
  }
}
